export default "__VITE_PUBLIC_ASSET__6e2e1fd5__"